import { render, staticRenderFns } from "./Founder.vue?vue&type=template&id=3f5e1ae4"
import script from "./Founder.vue?vue&type=script&lang=js"
export * from "./Founder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports